import type { Row } from "@tanstack/react-table";

export function dateDescNullsLastSortingFn<RowType>(
  rowA: Row<RowType>,
  rowB: Row<RowType>,
  columnId: string,
) {
  const a: string = rowA.getValue(columnId);
  const b: string = rowB.getValue(columnId);
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return new Date(b).getTime() - new Date(a).getTime();
}
